import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { PageHeader, Button, Card, Modal, Row, Col } from "antd";
import { useForm } from "react-hook-form";
//import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { reverse } from "named-urls";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { viewCompanySaga } from "./saga";
import * as selectors from "./selectors";
import { addressToStringMultiLine } from "../../../../utils/formatter";
import routes from "../../../../../routes";
//import AddAddressForm from "../../../../forms/AddAddressForm";
import EditAddressForm from "../../../../forms/EditAddressForm";
import addressSchema from "../../../../schemas/addressSchema";
import Loader from "../../../../components/Loader";

const AddressCard = ({ title, address, options }) => {
  const [showForm, setShowForm] = useState(false);
  const dispatch = useDispatch();
  const { companyId } = useParams();

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...address,
      city: address?.city?._id,
      state: address?.state?._id,
      country: address?.country?._id,
    },
    resolver: yupResolver(addressSchema),
  });

  const handleCancel = () => {
    reset();
    setShowForm(false);
  };

  const onSubmit = (data) => {
    const payload = {
      companyId,
      id: data._id,
      data,
      onSuccess: handleCancel,
    };
    dispatch(actions.updateAddress(payload));
  };

  return (
    <Card
      title={title}
      style={{ width: 300, marginBottom: 30 }}
      actions={
        [
          //Can be implemented for future options
          /*  <EditOutlined key="edit" onClick={() => setShowForm(true)} />,
        <DeleteOutlined key="delete" />, */
        ]
      }
    >
      <div style={{ minHeight: 120 }}>{addressToStringMultiLine(address)}</div>
      <Modal
        title="Edit Address"
        visible={showForm}
        centered
        onOk={handleSubmit(onSubmit)}
        onCancel={handleCancel}
        okText="Update"
      >
        <EditAddressForm
          errors={errors}
          control={control}
          watch={watch}
          options={options}
        />
      </Modal>
    </Card>
  );
};

const ViewCompany = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: viewCompanySaga });
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const history = useHistory();

  //const [showAddAddress, setShowAddAddress] = useState(false);

  useEffect(() => {
    dispatch(actions.fetchCompanyDetails({ id: companyId }));
    dispatch(actions.fetchCompanyBillingAddress({ id: companyId, query: "" }));
    dispatch(actions.fetchCompanyPickupAddress({ id: companyId, query: "" }));
    dispatch(actions.fetchCountries());
    dispatch(actions.fetchStates());
    dispatch(actions.fetchCities());
  }, [dispatch, companyId]);

  const companyData = useSelector(selectors.selectCompanyDetails) || {};
  const countries = useSelector(selectors.selectCountries);
  const states = useSelector(selectors.selectStates);
  const cities = useSelector(selectors.selectCities);
  const loading = useSelector(selectors.selectLoading);
  const fetchingCountries = useSelector(selectors.selectFetchingCountries);
  const fetchingStates = useSelector(selectors.selectFetchingStates);
  const fetchingCities = useSelector(selectors.selectFetchingCities);
  const pickupAddress = useSelector(selectors.selectCompanyPickupAddreses);
  const billingAddress = useSelector(selectors.selectCompanyBillingAddreses);
  // const addingAddress = useSelector(selectors.selectAddingAddress);
  // const updatingAddress = useSelector(selectors.selectUpdatingAddress);

  const showLoader =
    loading || fetchingCountries || fetchingStates || fetchingCities;
  const handleBack = () => {
    history.goBack();
  };

  /*const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type: "",
      addressLine1: "",
      addressLine2: "",
      district: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      landmark: "",
    },
    resolver: yupResolver(addressSchema),
  });

  const handleCancel = () => {
    reset();
    setShowAddAddress(false);
  };

  const onSubmit = (data) => {
    const payload = {
      id: companyId,
      data,
      onSuccess: handleCancel,
    };
    dispatch(actions.addAddress(payload));
  };
  */
  const getPaymentMethods = () => {
    const methods = [];
    const availableMethods = companyData?.paymentMethodsAvailable || [];
    availableMethods.forEach((method) => {
      methods.push(method.label);
    });
    return methods.join(", ");
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="Company Details"
        onBack={handleBack}
        subTitle={companyData.companyName}
        extra={[
          <Button key="2">
            <Link
              to={reverse(`${routes.backOffice.companies.details.users.list}`, {
                companyId,
              })}
            >
              Users
            </Link>
          </Button>,
          <Button key="1" type="primary">
            <Link
              to={reverse(`${routes.backOffice.companies.details.edit}`, {
                companyId,
              })}
            >
              Edit
            </Link>
          </Button>,
        ]}
      />
      {showLoader ? (
        <Loader />
      ) : (
        <div
          style={{
            height: "calc(100vh - 137px)",
            overflowY: "auto",
            padding: 24,
          }}
        >
          <div
            style={{ backgroundColor: "#fff", padding: 20, marginBottom: 30 }}
          >
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <p>
                  <strong>Company Name:</strong> {companyData.companyName}
                </p>
                <p>
                  <strong>Business Type:</strong>{" "}
                  {companyData.businessType?.label}
                </p>
                <p>
                  <strong>CIN Number:</strong> {companyData.cin}
                </p>
                <p>
                  <strong>Pickup Addreses:</strong> {pickupAddress?.length}{" "}
                  <strong>
                    <Link
                      style={{ paddingLeft: "10px" }}
                      to={reverse(
                        routes.backOffice.companies.details.pickupAddresses
                          .list,
                        {
                          companyId,
                        }
                      )}
                    >
                      ( View )
                    </Link>
                  </strong>
                </p>
              </div>
              <div style={{ flex: 1 }}>
                <p>
                  <strong>GST Number:</strong> {companyData.gst}
                </p>
                <p>
                  <strong>Business PAN:</strong> {companyData.pan}
                </p>
              </div>
              <div style={{ flex: 1 }}>
                <p>
                  <strong>Allow users to view prices: </strong>
                  {companyData?.priceVisible ? "Yes" : "No"}
                </p>
                <p>
                  <strong>Allow users to Add New Pickup Address: </strong>

                  {companyData?.allowUserPickupAddress ? "Yes" : "No"}
                </p>
                <p>
                  <strong>Payment Methods Available: </strong>
                  {getPaymentMethods()}
                </p>
                <p>
                  <strong>Billing Addreses</strong>: {billingAddress?.length}{" "}
                  <strong>
                    <Link
                      style={{ paddingLeft: "10px" }}
                      to={reverse(
                        routes.backOffice.companies.details.billingAddresses
                          .list,
                        {
                          companyId,
                        }
                      )}
                    >
                      ( View ){" "}
                    </Link>
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div style={{ marginBottom: 10 }}>
            <h1>
              Addresses{" "}
              {/*  <Button type="link" onClick={() => setShowAddAddress(true)}>
                (+ Add New)
              </Button> */}
            </h1>
            <Row gutter={32}>
              {companyData?.registeredAddress ? (
                <Col>
                  <AddressCard
                    title="Registered Address"
                    address={companyData?.registeredAddress}
                    options={{ countries, states, cities }}
                  />
                </Col>
              ) : (
                ""
              )}
              {/*companyData?.billingAddress?.map((address) => (
                <Col>
                  <AddressCard
                    title="Billing Address"
                    address={address}
                    options={{ countries, states, cities }}
                  />
                </Col>
              ))}
              {companyData?.pickupAddress?.map((address) => (
                <Col>
                  <AddressCard
                    title="Pickup Address"
                    address={address}
                    options={{ countries, states, cities }}
                  />
                </Col>
              ))*/}
            </Row>
          </div>
        </div>
      )}
      {/*  <Modal
        title="Add Address"
        visible={showAddAddress}
        centered
        onOk={handleSubmit(onSubmit)}
        onCancel={handleCancel}
        okText="Save"
      >
        <AddAddressForm
          errors={errors}
          control={control}
          watch={watch}
          options={{ countries, states, cities }}
        />
      </Modal> */}
    </div>
  );
};

export default ViewCompany;
